export enum TipoLiquidacion {
  AJE_FILMS_1 = 1,
  ASESORIAS_2 = 2,
}
